import { Card, Skeleton } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router';
import { Timeline } from '../../../components/Timeline';
import { useLanguage } from '../../../contexts/language';
import { DAYJS_VISUALIZATION_DATE_FORMAT } from '../../../utils/date';
import { JourneyTemplateSubPageContext } from './types';
import { PANEL_CARD_INNER_SPACING_CLASSNAME } from '../../../components/AdminTemplates';

const JourneyNotesPage = () => {
  const { journeyId, notesManagement } =
    useOutletContext<JourneyTemplateSubPageContext>();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const { notes, isLoading: isLoadingNotes } = notesManagement;

  useEffect(() => {
    /* There is scenario for redirection:
    1) notes have finished loading but there are none
    */
    if (!isLoadingNotes && !notes.length) {
      void navigate(`/admin/journeys/${journeyId}`);
    }
  }, [journeyId, navigate, isLoadingNotes, notes]);

  return (
    <Card className={PANEL_CARD_INNER_SPACING_CLASSNAME}>
      {isLoadingNotes ? (
        <Timeline<number>
          key="skeleton"
          items={[1, 2, 3]}
          getItemKey={id => id}
          renderItemContent={() => <Skeleton variant="rounded" />}
        />
      ) : (
        <Timeline
          key="notes"
          items={notes}
          getItemKey={({ id }) => id}
          renderItemHeader={({ type }) => t(`note-types.${type}`)}
          renderItemContent={({ creationDate, note }) => (
            <div>
              <div className="font-medium opacity-80 text-xs mb-4">
                {dayjs(creationDate).format(DAYJS_VISUALIZATION_DATE_FORMAT)}
              </div>
              <section className="text-sm opacity-80">
                {note.split('\n').map((text, index) => (
                  <p key={index} className="mb-2">
                    {text}
                  </p>
                ))}
              </section>
            </div>
          )}
        />
      )}
    </Card>
  );
};

export default JourneyNotesPage;
